export default __webpack_public_path__ + "static/Group58-3368701b1faf0b53a35139696e6a862f.svg";